import { CircleTickIcon, CircleWrongIcon, TimeIcon } from "../Assets/assets";
import { isValidArray, isValidObject } from "../Services/validators";
import {
  alignPhoneNumber,
  dateAndTimeConverter,
  isValidDate
} from "./constants";

export const getSelectedComplaintsDetailsData = (data) => {
  if (!isValidObject(data)) {
    return;
  }

  const { issuedBy, turnaround, status, documentId, location } = data;
  const getRefractedData = (key) => {
    switch (key) {
      case "documentId":
        return documentId || "N/A";

      case "source": {
        return getSourceTableValue(issuedBy?.type) || "N/A";
      }

      case "turnaround": {
        return turnaround
          ? convertTimestampToTimer(
              getRemainingTime(turnaround, +new Date()),
              status?.currentStatus === "CLOSED"
            )
          : "N/A";
      }

      case "linkedWith":
        const linkedWithData = issuedBy?.linkedWith || [];
        return linkedWithData.length > 0 ? (
          <div
            className="display-flex flex-direction-column inherit-parent-width overflow-scroll"
            style={{ maxHeight: "172px" }}
          >
            {linkedWithData.map((data, index) => {
              const { userDetails, issuedAt } = data || {};
              return (
                <div
                  className={`display-flex text-uppercase ${
                    index === 0 ? "" : "padding-top-default"
                  } ${
                    index === linkedWithData.length - 1
                      ? ""
                      : "padding-bottom-default"
                  }`}
                  key={index}
                >
                  {`${alignPhoneNumber(userDetails.phoneNumber) || "N/A"}  , ${
                    userDetails.name || "N/A"
                  } , ${dateAndTimeConverter(
                    issuedAt,
                    "Time"
                  )} , ${dateAndTimeConverter(issuedAt, "secondDate")}`}
                </div>
              );
            })}
          </div>
        ) : (
          "N/A"
        );

      case "location":
        return (
          `${location?.PCTNo?.toString().padStart(2, "0")} - ${
            location?.address
          }` || "N/A"
        );

      default:
        return "N/A";
    }
  };

  return [
    ["COMPLAINT ID", getRefractedData("documentId")],
    ["SOURCE", getRefractedData("source")],
    isValidArray(issuedBy?.linkedWith)
      ? ["LINKED WITH", getRefractedData("linkedWith")]
      : [],
    ["LOCATION", getRefractedData("location")]
  ];
};

export function getRemainingTime(turnaround, closedAt) {
  return closedAt ? turnaround - closedAt : turnaround - +new Date();
}

export function convertTimestampToTimer(timestamp, complaintClosed) {
  const positiveTimestamp = Math.abs(timestamp);

  const isNegative = timestamp <= 0;

  let seconds = Math.floor(positiveTimestamp / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  let days = Math.floor(hours / 24);

  seconds %= 60;
  minutes %= 60;
  hours %= 24;

  const pad = (num) => String(num).padStart(2, "0");

  const threeHours = 1000 * 60 * 60 * 3;

  return (
    <div
      className="display-flex"
      style={{
        ...(isNegative ? { color: "#D0405A" } : {}),
        ...(!isNegative && timestamp > threeHours
          ? { color: "var(--tertiaryColor)" }
          : {}),
        ...(!isNegative &&
        !complaintClosed &&
        timestamp < threeHours &&
        0 < timestamp
          ? { color: "#D17541" }
          : {})
      }}
    >
      {complaintClosed && isNegative ? <CircleWrongIcon /> : <></>}
      {!complaintClosed && isNegative ? <TimeIcon color={"#D0405A"} /> : <></>}
      {!complaintClosed && !isNegative ? (
        <TimeIcon
          color={
            timestamp < threeHours && 0 < timestamp
              ? "#D17541"
              : "var(--tertiaryColor)"
          }
        />
      ) : (
        <></>
      )}
      {complaintClosed && !isNegative ? <CircleTickIcon /> : <></>}

      <div className=" padding-left-small">
        {complaintClosed && !isNegative
          ? "On time"
          : complaintClosed && isNegative
          ? "Over time"
          : days
          ? `${isNegative ? "-" : ""} ${pad(days)}D : ${pad(hours)}H`
          : `${isNegative ? "-" : ""} ${pad(hours)}H : ${pad(minutes)}M`}
      </div>
    </div>
  );
}

export const getSelectedComplaintsManageData = (data) => {
  const getRefractedData = (key) => {
    const {
      takenOverBy,
      connectedPhoneNumbers,
      closedBy,
      closure,
      turnaround,
      penalty
    } = data || {};

    switch (key) {
      case "accessBy":
        return (
          <div>
            {connectedPhoneNumbers?.map((data, i) => (
              <div className="padding-top-default" key={i}>
                {data}
              </div>
            ))}
          </div>
        );

      case "underTakenBy":
        return (
          <div>
            {takenOverBy?.phoneNumber || takenOverBy?.email?.toLowerCase()}{" "}
            {", "}
            {takenOverBy?.employeeName || "N/A"}
          </div>
        );

      case "underTakenAt":
        return (
          <div>
            {takenOverBy?.takenOverAt
              ? `${dateAndTimeConverter(
                  takenOverBy.takenOverAt,
                  "Time"
                )}, ${dateAndTimeConverter(
                  takenOverBy.takenOverAt,
                  "secondDate"
                )}`
              : "N/A"}
          </div>
        );

      case "closedBy":
        return <div>{closedBy?.email || "N/A"}</div>;

      case "closedAt":
        return (
          <div>
            {dateAndTimeConverter(closure?.resolvedAt, "Time")} {", "}
            {dateAndTimeConverter(closure?.resolvedAt, "secondDate")}
          </div>
        );

      case "turnaround":
        return (
          <>
            {dateAndTimeConverter(turnaround, "Time")} {", "}
            {dateAndTimeConverter(turnaround, "secondDate")}
          </>
        );

      case "penalty":
        return <div>{penalty?.amount}</div>;

      default:
        return "N/A";
    }
  };

  return [
    !isValidObject(data?.takenOverBy) &&
    isValidArray(data?.connectedPhoneNumbers)
      ? ["ACCESS BY", getRefractedData("accessBy")]
      : [],
    isValidObject(data?.takenOverBy)
      ? ["UNDERTAKEN BY", getRefractedData("underTakenBy")]
      : [],
    isValidObject(data?.takenOverBy)
      ? ["UNDERTAKEN AT", getRefractedData("underTakenAt")]
      : [],
    data?.status?.currentStatus === "CLOSED"
      ? ["CLOSED BY", getRefractedData("closedBy")]
      : [],
    data?.status?.currentStatus === "CLOSED"
      ? ["CLOSED AT", getRefractedData("closedAt")]
      : [],
    // data?.turnaround ? ["TURNAROUND TIME", getRefractedData("turnaround")] : [],
    data?.penalty?.amount ? ["PENALTY", getRefractedData("penalty")] : []
  ];
};

export const getSelectedComplaintsUpdatesData = (data) => {
  const getValidCard = (status) => {
    return (
      <div
        style={{
          width: "fit-content",
          height: "fit-content",
          padding: "4px 8px",
          fontSize: "10px",
          borderRadius: "4px",
          backgroundColor:
            status === "CLOSED"
              ? "#00892F29"
              : status === "UNDER REVIEW"
              ? "rgba(246, 201, 88, 0.12)"
              : status === "PENDING CLOSURE"
              ? "rgba(46, 169, 255, 0.12)"
              : "#FF4C4C1A",
          color:
            status === "CLOSED"
              ? "#00892F"
              : status === "UNDER REVIEW"
              ? "rgba(181, 132, 0, 1)"
              : status === "PENDING CLOSURE"
              ? "rgba(0, 150, 255, 1) "
              : "#FF4C4C"
        }}
      >
        <div className="white-space-nowrap">{status}</div>
      </div>
    );
  };
  const getRefractedData = (key) => {
    const { updatedAt, updatedBy, currentStatus, previousStatus, proof } = data;

    switch (key) {
      case "status":
        return currentStatus ? (
          <div className="display-flex flex-justify-content-center flex-align-items-center width-fit-content">
            {previousStatus ? (
              <>
                {getValidCard(previousStatus)}
                <div className="padding-left-default padding-right-default">
                  {" "}
                  &rarr;
                </div>
              </>
            ) : (
              <></>
            )}
            {getValidCard(currentStatus)}
          </div>
        ) : (
          "N/A"
        );

      case "updatedAt":
        return updatedAt
          ? `${dateAndTimeConverter(updatedAt, "Time")}, ${dateAndTimeConverter(
              updatedAt,
              "secondDate"
            )}`
          : "N/A";

      case "updatedBy": {
        const { employeeName, name, phoneNumber, email } = updatedBy || {};
        return `${alignPhoneNumber(phoneNumber) || email || "N/A"} , ${
          employeeName || name || "N/A"
        }`;
      }

      case "supportingMedia":
        return proof?.length || 0;

      default:
        return "N/A";
    }
  };

  return [
    typeof data.currentStatus === "string"
      ? ["STATUS", getRefractedData("status")]
      : [],
    ["UPDATED ON", getRefractedData("updatedAt")],
    ["UPDATED BY", getRefractedData("updatedBy")],
    data.proof?.length > 0
      ? ["SUPPORTING MEDIA", getRefractedData("supportingMedia")]
      : []
  ];
};

export function getSourceTableValue(value) {
  switch (value) {
    case "independentEngineer":
      return "Independent Engineers";
    case "public":
      return "Public";
    case "procedure":
      return "Procedure";
    case "customerSupport":
      return "Customer Support";
    case "internal":
      return "Internal";
    default:
      return value;
  }
}

export const complaintsQueryPath = {
  status: "status.currentStatus",
  issueRaised: "issuedBy.userDetails.phoneNumber",
  issueTakenByPhoneNumber: "takenOverBy.phoneNumber",
  issueTakenByEmail: "takenOverBy.email",
  category: "category",
  ward: "location.ward",
  zone: "location.zone",
  dateRange: "createdAt",
  PCTNo: "location.id",
  source: "issuedBy.type"
};

export const complaintsQueryBuilder = (filterData, locationData) => {
  const query = [];

  const addQuery = (path, operator, value) => {
    query.push(path, operator, value);
  };

  const addRangeQuery = (path, from, to) => {
    addQuery(path, ">=", +new Date(`${from}:00:00:00`));
    addQuery(path, "<=", +new Date(`${to}:23:59:59`));
  };

  Object.entries(filterData).forEach(([key, value]) => {
    if (!value) {
      return;
    }

    switch (key) {
      case "dateRange":
        if (
          value.from &&
          isValidDate(value.from) &&
          value.to &&
          isValidDate(value.to)
        ) {
          addRangeQuery(complaintsQueryPath[key], value.from, value.to);
        }
        break;

      case "PCTNo": {
        if (locationData && isValidArray(value)) {
          const locationIds = value
            .map((PCTNo) =>
              Object.values(locationData).find((data) => data.PCTNo === PCTNo)
            )
            .filter((loc) => loc?.documentId)
            .map((loc) => loc.documentId);

          if (isValidArray(locationIds)) {
            addQuery(complaintsQueryPath[key], "in", locationIds);
          }
        }
        break;
      }

      case "issueRaised": {
        if (value && typeof value === "string" && value.trim()) {
          addQuery(complaintsQueryPath[key], "==", `${value.trim()}`);
        }
        break;
      }

      case "category": {
        if (isValidArray(value)) {
          const allCategories = [];

          value.forEach((v) => {
            if (v) {
              allCategories.push(v);
              if (categoryMapping[v]) {
                allCategories.push(categoryMapping[v]);
              }
            }
          });

          const uniqueCategories = [...new Set(allCategories)];

          addQuery(complaintsQueryPath[key], "in", uniqueCategories);
        }
        break;
      }

      case "source":
        if (isValidArray(value)) {
          addQuery(complaintsQueryPath[key], "in", value);
        }
        break;

      default: {
        if (isValidArray(value)) {
          addQuery(complaintsQueryPath[key], "in", value);
        }
        break;
      }
    }
  });

  return query;
};

export const categoryMapping = {
  "Broken doors, latches": "உடைந்த கதவுகள், தாழ்பாள்கள்",
  "Fees are charged": "கட்டணம் வசூலிக்கப்படுகிறது",
  "Janitors are not on duty": "பராமரிப்பாளர் பணியில் இல்லை",
  "Lack of security measures": "பாதுகாப்பு குறைபாடு (பாதுகாப்புஇல்லாத கழிவறை)",
  "Lights not working": "விளக்குகள் எரியவில்லை",
  "No water supply": "தண்ணீர் வரவில்லை",
  "Restroom is not open": "கழிப்பறை திறக்கப்படவில்லை",
  "Unhygienic environment": "சுற்றுபுறம் தூய்மையாக இல்லை",
  "Unsanitary restroom": "சுத்தமில்லாத கழிவறை",
  "Waterlogged in the drainage": "கழிவு நீர் குழாயில் அடைப்பு"
};

export const sourceMapping = {
  Public: "public",
  Procedure: "procedure",
  "Customer Support": "customerSupport",
  "Independent Engineers": "independentEngineer"
};
